import { render, staticRenderFns } from "./DatumView.vue?vue&type=template&id=22917c4c&scoped=true"
import script from "./DatumView.vue?vue&type=script&lang=js"
export * from "./DatumView.vue?vue&type=script&lang=js"
import style0 from "./DatumView.vue?vue&type=style&index=0&id=22917c4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22917c4c",
  null
  
)

export default component.exports